import React, { createContext, useContext, useReducer, ReactNode } from 'react';
import {
    UnidadeSaudeDetailsState,
    UnidadeSaudeDetailsAction,
    UnidadeSaudeDetailsReducer,
} from './unidade-saude-details-reducer';

const initialState: UnidadeSaudeDetailsState = {
    unidadeSaudeDetails: null,
    loading: false,
    error: null,
};

const UnidadeSaudeDetailsStateContext = createContext<UnidadeSaudeDetailsState | undefined>(undefined);
const UnidadeSaudeDetailsDispatchContext = createContext<React.Dispatch<UnidadeSaudeDetailsAction> | undefined>(undefined);

interface UnidadeSaudeDetailsProviderProps {
    children: ReactNode;
}

export const UnidadeSaudeDetailsProvider: React.FC<UnidadeSaudeDetailsProviderProps> = ({ children }) => {
    const [state, dispatch] = useReducer(UnidadeSaudeDetailsReducer, initialState);

    return (
        <UnidadeSaudeDetailsStateContext.Provider value={state}>
            <UnidadeSaudeDetailsDispatchContext.Provider value={dispatch}>
                {children}
            </UnidadeSaudeDetailsDispatchContext.Provider>
        </UnidadeSaudeDetailsStateContext.Provider>
    );
};

export const useUnidadeSaudeDetailsState = (): UnidadeSaudeDetailsState => {
    const context = useContext(UnidadeSaudeDetailsStateContext);
    if (context === undefined) {
        throw new Error('useUnidadeSaudeDetailsState must be used within a UnidadeSaudeDetailsProvider');
    }
    return context;
};

export const useUnidadeSaudeDetailsDispatch = (): React.Dispatch<UnidadeSaudeDetailsAction> => {
    const context = useContext(UnidadeSaudeDetailsDispatchContext);
    if (context === undefined) {
        throw new Error('useUnidadeSaudeDetailsDispatch must be used within a UnidadeSaudeDetailsProvider');
    }
    return context;
};
